module.exports = __webpack_public_path__ + "img/feature1.34a262ca.png";